import React from 'react';

import { ChevronRightRegularIcon } from '../../../../../../shared/icons/icons';

import styles from './product-list-profile-chip.scss';

interface ProductListProfileChipProps {
  children: React.ReactNode;
  onClick: () => void;
}

function ProductListProfileChip(props: ProductListProfileChipProps) {
  const { children, onClick } = props;

  return (
    <button className={styles['container']} onClick={onClick}>
      <div className={styles['label']}>{children}</div>
      <ChevronRightRegularIcon className={styles['icon']} />
    </button>
  );
}

export default ProductListProfileChip;
